import { render, staticRenderFns } from "./relationOpenUrl.vue?vue&type=template&id=7f66e242"
import script from "./relationOpenUrl.vue?vue&type=script&lang=js"
export * from "./relationOpenUrl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports